import { BPanel, Breadcrumb } from '@sketchpixy/rubix';
import { Link } from 'react-router';
import { Roles } from 'roles';
import { TextField, SubmitField } from 'uniforms-bootstrap3';
import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import { Meteor } from 'meteor/meteor';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';

import { UserSchema } from '../../collections/users/users';
import {
	updateCertificat,
	updatePassword,
	updateLicence
} from '../../collections/users/methods';
import DatePickerField from '../fields/datePickerField';
import MgfForm from '../common/mgfForm';

export default class AccountPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};

		this.user = Meteor.user();

		this.ChangePasswordSchema = new SimpleSchema({
			"password": {
				type: String,
				label: "Mot de passe",
				min: 8,
				uniforms: {
					type: "password"
				}
			}
		});

		this.ChangeCertificatSchema = new SimpleSchema({
			"certificat": {
				type: String,
				label: "Certificat",
				uniforms: {
            		component: DatePickerField
        		}
			}
		});

		this.ChangeLicenceSchema = new SimpleSchema({
			"licence": {
				type: String,
				label: "Licence",
				uniforms: {
            		component: DatePickerField
        		}
			}
		});
	}

	handleSubmit(doc) {
	}

	handlePasswordChange(doc) {
		return new Promise((resolve, reject) => {
			updatePassword.call(_.pick(doc, '_id', 'password'),
								(error, result) => {
									console.error(error);
									if (!error) {
										resolve(doc);
									}
									reject(error);
								});
		});
	}

	handleCertificatChange(doc) {
		return new Promise((resolve, reject) => {
			updateCertificat.call(_.pick(doc, '_id', 'certificat'),
				(error, result) => {
					console.error(error);
					if (!error) {
						resolve(doc);
					}
					reject(error);
				});
		});
	}

	handleLicenceChange(doc) {
		return new Promise((resolve, reject) => {
			updateLicence.call(_.pick(doc, '_id', 'licence'),
				(error, result) => {
					console.error(error);
					if (!error) {
						resolve(doc);
					}
					reject(error);
				});
		});
	}

	render() {
		return (
			<div>
				<Breadcrumb>
					<Breadcrumb.Item>
						<Link to="/account">Mon compte</Link>
					</Breadcrumb.Item>
				</Breadcrumb>
				<BPanel header="Modifier mon profil">
					<MgfForm schema={UserSchema.omit('roles', 'roles.$')} collection={Meteor.users} model={this.user} onSubmit={this.handleSubmit.bind(this)} />
				</BPanel>

				{Roles.userHasRole(this.user._id, 'pilot') &&
				<BPanel header="Date d'expiration du certificat médical">
					<MgfForm schema={this.ChangeCertificatSchema} collection={ { label: "Date d'expiration" } } model={this.user} doSave={false} onSubmit={this.handleCertificatChange.bind(this)}>
						<DatePickerField name="certificat" value={this.user.profile.certificat}/>
						<SubmitField value="Changer" />
					</MgfForm>
				</BPanel>
				}

				{Roles.userHasRole(this.user._id, 'pilot') &&
				<BPanel header="Date d'expiration de la licence de pilote">
					<MgfForm schema={this.ChangeLicenceSchema} collection={ { label: "Date d'expiration" } } model={this.user} doSave={false} onSubmit={this.handleLicenceChange.bind(this)}>
						<DatePickerField name="licence" value={this.user.profile.licence}/>
						<SubmitField value="Changer" />
					</MgfForm>
				</BPanel>
				}

				<BPanel header="Mettre à jour mon mot de passe">
					<MgfForm schema={this.ChangePasswordSchema} collection={ { label: "Le mot de passe" } } model={this.user} doSave={false} onSubmit={this.handlePasswordChange.bind(this)}>
						<TextField name="password" />
						<SubmitField value="Changer" />
					</MgfForm>
				</BPanel>
			</div>
		);
	}
}

AccountPage.contextTypes = {
	router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/users/Account.page.js
 **/